/* KIT CRATES theme JS — no dependencies */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    const fmt = (window.KC && KC.moneyFormat) || '${{amount}}';
    const v = (cents / 100).toFixed(2);
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(() => toastEl.classList.remove('is-on'), 2600);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(id) { const d = document.getElementById(id); if (!d) return; d.classList.add('is-open'); document.body.style.overflow = 'hidden'; const f = $('input,button,a', $('.drawer__panel', d)); f && f.focus(); }
  function closeDrawers() { $$('.drawer.is-open').forEach(d => d.classList.remove('is-open')); document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open-drawer]'); if (o) { e.preventDefault(); openDrawer(o.dataset.openDrawer); return; }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('drawer__scrim')) closeDrawers();
    const st = e.target.closest('[data-toggle-search]'); if (st) { const b = $('#SearchBar'); b.classList.toggle('is-open'); if (b.classList.contains('is-open')) $('input', b).focus(); }
    const ft = e.target.closest('[data-toggle-filters]'); if (ft) $('#Filters').classList.toggle('is-open');
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawers(); $('#SearchBar') && $('#SearchBar').classList.remove('is-open'); } });

  /* close desktop mega menus on outside click */
  document.addEventListener('click', (e) => { $$('.header__nav details[open]').forEach(d => { if (!d.contains(e.target)) d.removeAttribute('open'); }); });


  /* ---------- Sticky header (Shopify wraps sections; make the wrapper sticky) + scroll shadow ---------- */
  const hw = $('#Header');
  if (hw) {
    const sec = hw.closest('.shopify-section'); if (sec) sec.classList.add('kc-sticky');
    const onS = () => hw.classList.toggle('is-scrolled', window.scrollY > 4);
    onS(); window.addEventListener('scroll', onS, { passive: true });
  }

  /* ---------- Desktop nav: fold overflowing items into a "More" menu ---------- */
  const navUl = $('.header__nav');
  if (navUl) {
    const items = $$(':scope > li', navUl);
    let more = null;
    const moreList = () => { if (!more) { more = document.createElement('li'); more.className = 'has-mega header__more'; more.innerHTML = '<details><summary>More <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></summary><div class="mega"><ul class="mega__list"></ul></div></details>'; navUl.appendChild(more); } return $('.mega__list', more); };
    const toLink = (li) => { const l = document.createElement('li'); const a = $('details > summary', li) ? $('.mega__all', li) : $('a', li); l.innerHTML = `<a href="${a ? a.getAttribute('href') : '#'}">${($('summary', li) || $('a', li)).textContent.replace(/\s+/g, ' ').trim()}</a>`; l._orig = li; return l; };
    const header = navUl.closest('.header');
    const fit = () => {
      if (window.innerWidth <= 900) return;
      // restore everything, then try a compact layout, then fold from the end only if it still overflows
      if (more) { $$('.mega__list > li', more).forEach(l => { navUl.insertBefore(l._orig, more); }); more.remove(); more = null; }
      header && header.classList.remove('header--compact', 'header--tight');
      if (navUl.scrollWidth > navUl.clientWidth + 1 && header) { header.classList.add('header--compact'); }
      if (navUl.scrollWidth > navUl.clientWidth + 1 && header) { header.classList.add('header--tight'); }
      let guard = 0;
      while (navUl.scrollWidth > navUl.clientWidth + 1 && guard++ < items.length) {
        const cand = $$(':scope > li:not(.header__more)', navUl); const last = cand[cand.length - 1]; if (!last || cand.length < 2) break;
        const list = moreList(); list.insertBefore(toLink(last), list.firstChild); last.remove();
      }
    };
    fit(); let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(fit, 120); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  }


  /* desktop: open mega menus on hover (details content is not painted while closed) */
  if (window.matchMedia('(hover:hover)').matches) {
    $$('.header__nav > li.has-mega').forEach(li => {
      const d = $('details', li); let t;
      li.addEventListener('mouseenter', () => { clearTimeout(t); $$('.header__nav details[open]').forEach(o => { if (o !== d) o.removeAttribute('open'); }); d.open = true; });
      li.addEventListener('mouseleave', () => { t = setTimeout(() => { d.open = false; }, 120); });
    });
    // items folded into "More" are created later; delegate
    document.addEventListener('mouseover', (e) => { const li = e.target.closest('.header__more'); if (li && !li._bound) { li._bound = true; const d = $('details', li); let t; li.addEventListener('mouseenter', () => { clearTimeout(t); d.open = true; }); li.addEventListener('mouseleave', () => { t = setTimeout(() => { d.open = false; }, 120); }); d.open = true; } });
  }

  /* ---------- Predictive search ---------- */
  const si = $('#SearchInput');
  if (si) {
    let t;
    si.addEventListener('input', () => {
      clearTimeout(t);
      const q = si.value.trim(); const box = $('#Predictive');
      if (q.length < 2) { box.classList.remove('is-open'); return; }
      t = setTimeout(async () => {
        try {
          const r = await fetch(`${KC.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`);
          const j = await r.json(); const items = j.resources.results.products || [];
          box.innerHTML = items.length ? `<div class="predictive__grid">${items.map(p => `<a class="predictive__item" href="${p.url}"><img src="${p.featured_image ? p.featured_image.url + '&width=120' : ''}" alt=""><span>${p.title}<br><b>${p.price}</b></span></a>`).join('')}</div>` : `<p class="lede">No kits match "${q}". Try a club or country.</p>`;
          box.classList.add('is-open');
        } catch (err) { /* ignore */ }
      }, 220);
    });
  }

  /* ---------- Cart: order note (autosaved) ---------- */
  const cartUpdate = (body) => fetch(`${KC.root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  let noteTimer = null, notePending = null, noteSaving = null;
  const noteStatus = (txt) => $$('[data-note-status]').forEach(s => { s.textContent = txt; });
  const noteTitles = (has) => $$('[data-note-title]').forEach(t => { t.textContent = has ? t.dataset.has : t.dataset.empty; });
  async function saveNote(v) {
    noteSaving = (async () => {
      try {
        const r = await cartUpdate({ note: v }); if (!r.ok) throw new Error();
        $$('[data-cart-note]').forEach(x => { if (x.value !== v) x.value = v; });
        noteStatus(v.trim() ? 'Saved' : ''); noteTitles(!!v.trim());
      } catch (_) { noteStatus('Not saved — check your connection'); }
    })();
    await noteSaving; noteSaving = null;
  }
  async function flushNote() {
    if (noteTimer) { clearTimeout(noteTimer); noteTimer = null; const v = notePending; notePending = null; if (v !== null) await saveNote(v); }
    if (noteSaving) await noteSaving;
  }
  document.addEventListener('input', (e) => {
    const n = e.target.closest('[data-cart-note]'); if (!n) return;
    notePending = n.value; noteStatus('Saving…'); clearTimeout(noteTimer);
    noteTimer = setTimeout(() => { noteTimer = null; const v = notePending; notePending = null; saveNote(v); }, 500);
  });
  document.addEventListener('focusout', (e) => { if (e.target.closest && e.target.closest('[data-cart-note]')) flushNote(); });

  /* ---------- Cart: pre-order acknowledgement ---------- */
  function syncAck() {
    $$('[data-cart-form]').forEach(f => {
      const c = $('[data-preorder-ack]', f); const b = $('[data-checkout]', f); if (!b) return;
      const locked = !!(c && !c.checked);
      b.classList.toggle('is-locked', locked); b.setAttribute('aria-disabled', locked ? 'true' : 'false');
    });
  }
  document.addEventListener('change', async (e) => {
    const c = e.target.closest('[data-preorder-ack]'); if (!c) return;
    const on = c.checked; $$('[data-preorder-ack]').forEach(x => { x.checked = on; });
    syncAck();
    try { await cartUpdate({ attributes: { 'Pre-order acknowledged': on ? c.value : '' } }); } catch (_) { /* the form posts the attribute at checkout anyway */ }
  });
  /* checkout click runs before native validation, so we can nudge instead of the browser bubble */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-checkout]'); if (!b) return;
    const f = b.closest('[data-cart-form]'); const c = f && $('[data-preorder-ack]', f);
    if (c && !c.checked) {
      e.preventDefault();
      const box = c.closest('[data-ack-box]'); if (box) { box.classList.remove('is-nudge'); void box.offsetWidth; box.classList.add('is-nudge'); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      c.focus(); toast('Please confirm the pre-order time first');
    }
  });
  document.addEventListener('submit', async (e) => {
    const f = e.target; if (!f.matches || !f.matches('[data-cart-form]')) return;
    if ((noteTimer || noteSaving) && !f._flushed) {
      e.preventDefault(); const btn = $('[data-checkout]', f);
      await flushNote(); f._flushed = true;
      if (btn && f.requestSubmit) f.requestSubmit(btn); else f.submit();
    }
  });
  syncAck();

  /* ---------- Cart ---------- */
  /* Free-gift lines carry _gift_for = the product they came with; drop them when that product left the cart */
  async function cleanupGifts(cart) {
    try {
      const c = cart || await (await fetch(`${KC.root}cart.js`)).json();
      const pids = new Set(c.items.map(i => String(i.product_id)));
      const orphans = c.items.filter(i => i.properties && i.properties._gift_for && !pids.has(String(i.properties._gift_for)));
      for (const o of orphans) await fetch(`${KC.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: o.key, quantity: 0 }) });
      return orphans.length;
    } catch (_) { return 0; }
  }
  async function refreshCartDrawer(open) {
    try {
      await flushNote();
      if (await cleanupGifts()) { /* removed orphan gifts; render the updated cart below */ }
      const r = await fetch(`${KC.root}?sections=cart-drawer&t=${Date.now()}`, { cache: 'no-store' }); const j = await r.json();
      const tmp = document.createElement('div'); tmp.innerHTML = j['cart-drawer'];
      const fresh = $('#CartDrawer', tmp); const cur = $('#CartDrawer');
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; }
      syncAck();
      const c = await (await fetch(`${KC.root}cart.js`)).json();
      $$('[data-cart-count]').forEach(el => { el.textContent = c.item_count; el.dataset.count = c.item_count; });
      if (open) openDrawer('CartDrawer');
    } catch (e) { if (open) location.href = KC.root + 'cart'; }
  }
  window.KCcart = { refresh: refreshCartDrawer };

  document.addEventListener('submit', async (e) => {
    const form = e.target;
    if (!form.matches('[data-ajax-add]')) return;
    e.preventDefault();
    const btn = $('[type=submit]', form); const label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      const fd = new FormData(form);
      // Only send print properties that are actually filled in (and none when the print panel is closed)
      const printBox = $('details[data-print]', form); const printOpen = !printBox || printBox.open;
      const props = {}; const qty = Math.max(1, parseInt(fd.get('quantity') || '1', 10));
      Array.from(fd.keys()).forEach(k => { const m = k.match(/^properties\[(.+)\]$/); if (m) { const v = String(fd.get(k)).trim(); if (printOpen && v) props[m[1]] = v; } });
      const items = [{ id: fd.get('id'), quantity: qty, properties: props }];
      // Patches are separate priced products, linked to the kit via a "For" property
      if (printOpen) $$('[data-patch]:checked', form).forEach(p => { if (p.dataset.variant) items.push({ id: p.dataset.variant, quantity: qty, properties: { For: (form.dataset.productTitle || 'Kit') + (props.Name ? ' · ' + props.Name : '') + (props.Number ? ' ' + props.Number : '') } }); });
      // Free gifts picked on the page (theme-gifts.js) ride along as their own lines
      if (form._extraItems) form._extraItems.forEach(x => items.push({ id: x.id, quantity: qty, properties: x.properties }));
      const r = await fetch(`${KC.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || j.message || 'Could not add');
      await refreshCartDrawer(true);
      toast('Added to your crate');
    } catch (err) { toast(err.message); }
    btn.disabled = false; btn.textContent = label;
  });

  /* quick add from cards */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return;
    e.preventDefault(); b.disabled = true;
    try {
      const r = await fetch(`${KC.root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: b.dataset.quickAdd, quantity: 1 }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Could not add');
      await refreshCartDrawer(true); toast('Added to your crate');
    } catch (err) { toast(err.message); }
    b.disabled = false;
  });

  /* line quantity / remove (drawer + cart page) */
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-line-qty]'); const rm = e.target.closest('[data-line-remove]');
    if (!q && !rm) return; e.preventDefault();
    const el = q || rm; const line = el.dataset.line; let quantity;
    if (rm) quantity = 0; else { const inp = $(`input[data-line-input="${line}"]`, el.closest('.qty')); quantity = Math.max(0, parseInt(inp.value || '1', 10) + parseInt(el.dataset.lineQty, 10)); }
    try {
      await flushNote();
      const r = await fetch(`${KC.root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (!r.ok) throw new Error('Could not update');
      if ($('#CartPage')) location.reload(); else refreshCartDrawer(false);
    } catch (err) { toast(err.message); }
  });

  if ($('#CartPage')) cleanupGifts().then(n => { if (n) location.reload(); });

  /* qty steppers (product) */
  document.addEventListener('click', (e) => {
    const s = e.target.closest('[data-qty-step]'); if (!s) return;
    const inp = $('input', s.closest('.qty')); inp.value = Math.max(1, parseInt(inp.value || '1', 10) + parseInt(s.dataset.qtyStep, 10)); inp.dispatchEvent(new Event('change'));
  });

  /* ---------- Nameset preview (hero + product) ---------- */
  function bindNameset(scope) {
    const name = $('[data-ns-name]', scope), num = $('[data-ns-num]', scope);
    const outName = $$('[data-ns-out-name]', scope), outNum = $$('[data-ns-out-num]', scope);
    if (!name && !num) return;
    const clean = (v) => v.toUpperCase().replace(/[^A-Z0-9 .'\-]/g, '').slice(0, 14);
    const paint = () => {
      const n = name ? clean(name.value) : ''; const d = num ? num.value.replace(/\D/g, '').slice(0, 2) : '';
      outName.forEach(o => { o.textContent = n || o.dataset.nsOutName || ''; o.style.fontSize = (n.length > 10 ? 26 : n.length > 8 ? 30 : 34) + 'px'; });
      outNum.forEach(o => o.textContent = d || o.dataset.nsOutNum || '');
      if (name) name.value = n; if (num) num.value = d;
      scope.dispatchEvent(new CustomEvent('nameset:change', { detail: { name: n, number: d } }));
    };
    name && name.addEventListener('input', paint); num && num.addEventListener('input', paint);
  }
  $$('[data-nameset]').forEach(bindNameset);

  /* hero: carry name/number into product pages via sessionStorage */
  const heroForm = $('[data-hero-nameset]');
  if (heroForm) {
    heroForm.addEventListener('submit', (e) => {
      try { sessionStorage.setItem('kc_ns', JSON.stringify({ name: $('[data-ns-name]', heroForm).value, number: $('[data-ns-num]', heroForm).value })); } catch (_) {}
    });
  }

  /* ---------- Product form ---------- */
  const pf = $('[data-product-form]');
  if (pf) {
    const variants = JSON.parse($('[data-variants]').textContent);
    const idInput = $('input[name="id"]', pf);
    const addBtn = $('[data-add]', pf);
    const priceBox = $('[data-price]');
    const stickyPrice = $('[data-sticky-price]');
    const optionInputs = $$('.opt__values input', pf);

    function currentVariant() {
      const sel = $$('.opt', pf).map(o => { const c = $('input:checked', o); return c ? c.value : null; });
      return variants.find(v => v.options.every((o, i) => o === sel[i]));
    }
    function renderPrice(v) {
      if (!v) return;
      let html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) {
        const off = Math.round((1 - v.price / v.compare_at_price) * 100);
        html = `<span class="price__sale">${money(v.price)}</span><s class="price__compare">${money(v.compare_at_price)}</s><span class="price__off">-${off}%</span>`;
      } else html = `<span>${money(v.price)}</span>`;
      if (priceBox) priceBox.innerHTML = html; if (stickyPrice) stickyPrice.innerHTML = html;
    }
    function markAvailability() {
      $$('.opt', pf).forEach((opt, idx) => {
        $$('input', opt).forEach(inp => {
          const sel = $$('.opt', pf).map((o, i) => i === idx ? inp.value : ($('input:checked', o) || {}).value);
          const match = variants.find(v => v.options.every((o, i) => o === sel[i]));
          inp.nextElementSibling.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    /* gallery: one function used by the thumbnails and by variant changes */
    const thumbs = $$('[data-thumb]'); const mains = $$('[data-main-img]');
    function showMedia(id, fromUser) {
      if (!id) return; id = String(id);
      if (!mains.some(m => String(m.dataset.mainImg) === id)) return;
      mains.forEach(m => m.classList.toggle('is-active', String(m.dataset.mainImg) === id));
      thumbs.forEach(t => { const on = String(t.dataset.thumb) === id; if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); if (on && fromUser && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
    }
    let lastMedia = null;
    function update(fromUser) {
      const v = currentVariant();
      markAvailability();
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id; renderPrice(v);
      // show the selected variant's own photo (e.g. the chosen colour)
      const mid = (v.featured_media && v.featured_media.id) || (v.featured_image && v.featured_image.id);
      if (mid && mid !== lastMedia) { lastMedia = mid; showMedia(mid, fromUser === true); }
      const pre = pf.dataset.preorder === 'true';
      addBtn.disabled = !v.available;
      addBtn.textContent = !v.available ? 'Sold out' : pre ? addBtn.dataset.labelPreorder : addBtn.dataset.labelStock;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      $$('.opt', pf).forEach(o => { const c = $('input:checked', o); const em = $('.opt__label em', o); if (em && c) em.textContent = c.value; });
    }
    optionInputs.forEach(i => i.addEventListener('change', () => update(true)));
    update(false);

    /* printing toggle: enable/disable properties so they're only sent when on */
    const print = $('details[data-print]', pf);
    if (print) {
      const sync = () => { print.classList.toggle('is-on', print.open); if (!print.open) { $$('input:not([type=checkbox]),select', print).forEach(i => { i.value = ''; }); $$('[data-patch]', print).forEach(i => { i.checked = false; i.dispatchEvent(new Event('change')); }); $$('[data-ns-name]', print).forEach(i => i.dispatchEvent(new Event('input'))); } else { const n = $('[data-ns-name]', print); n && setTimeout(() => n.focus(), 50); } };
      print.addEventListener('toggle', sync); $('summary', print).addEventListener('click', () => setTimeout(sync, 0));
      try { const ns = JSON.parse(sessionStorage.getItem('kc_ns') || 'null'); if (ns && (ns.name || ns.number)) { print.open = true; const n = $('[data-ns-name]', print), d = $('[data-ns-num]', print); if (n) n.value = ns.name; if (d) d.value = ns.number; n && n.dispatchEvent(new Event('input')); sync(); sessionStorage.removeItem('kc_ns'); } } catch (_) {}
    }

    /* patches: write the names into a property and show a running total */
    const patches = $$('[data-patch]', pf); const patchProp = $('[data-patches-prop]', pf); const totalBox = $('[data-buy-total]', pf);
    const paintPatches = () => {
      const on = patches.filter(p => p.checked);
      if (patchProp) patchProp.value = on.map(p => p.dataset.title).join(', ');
      if (totalBox) {
        const v = currentVariant(); const extra = on.reduce((a, p) => a + parseInt(p.dataset.price || '0', 10), 0);
        totalBox.hidden = !(on.length && v);
        if (on.length && v) { $('[data-total-base]', totalBox).textContent = money(v.price); $('[data-total-patches]', totalBox).textContent = money(extra); $('[data-total-sum]', totalBox).textContent = money(v.price + extra); }
      }
    };
    patches.forEach(p => p.addEventListener('change', paintPatches)); optionInputs.forEach(i => i.addEventListener('change', paintPatches)); paintPatches();

    /* gallery thumbnails */
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumb, false)));

    /* sticky buy on mobile */
    const sticky = $('.sticky-buy');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sticky.classList.toggle('is-on', !en.isIntersecting), { rootMargin: '-60px 0px 0px 0px' }).observe(addBtn);
      $('[data-sticky-go]', sticky) && $('[data-sticky-go]', sticky).addEventListener('click', () => addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }));
    }
  }

  /* ---------- Batch countdown ---------- */
  $$('[data-countdown]').forEach(el => {
    const end = new Date(el.dataset.countdown).getTime(); if (isNaN(end)) return;
    const d = $('[data-cd-d]', el), h = $('[data-cd-h]', el), m = $('[data-cd-m]', el);
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      const dd = Math.floor(diff / 864e5); diff -= dd * 864e5;
      const hh = Math.floor(diff / 36e5); diff -= hh * 36e5;
      const mm = Math.floor(diff / 6e4);
      d.textContent = dd; h.textContent = String(hh).padStart(2, '0'); m.textContent = String(mm).padStart(2, '0');
      if (end - Date.now() <= 0 && el.dataset.closedText) el.innerHTML = `<strong>${el.dataset.closedText}</strong>`;
    };
    tick(); setInterval(tick, 30000);
  });

  /* ---------- Collection filters: auto-submit ---------- */
  const ff = $('#FilterForm');
  if (ff) { ff.addEventListener('change', (e) => { if (e.target.matches('input[type=checkbox],select')) ff.requestSubmit(); }); }
  const sort = $('#SortBy');
  if (sort) sort.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u; });
})();
